module.exports = __webpack_public_path__ + "static/media/ad-slide-02.7f86ff38.jpg";